import { Navigate, useLocation } from 'react-router-dom';
import Loading from './Loading';

const SigninRequired = ({ authenticated }) => {
    const location = useLocation();

    if (authenticated === false) {
        const returnPath = `${location.pathname}${location.search}${location.hash}`;
        return <Navigate to={`/sign_in?redirect=${encodeURIComponent(returnPath)}`}
            state={{ signinCancelToHome: true }} replace />;
    }

    return (
        <div className='container appScreen' role='status' aria-label='Loading account'>
            <Loading />
        </div>
    );
};

export default SigninRequired;
